// // Cart Drawer Selling Plan Toggle

  document.addEventListener('click', (e) => {
    // Toggle dropdown visibility when clicking the button
    if (e.target.closest('.cart-line-item--quantity-dropdown__btn')) {
      const dropdown = e.target.closest('.cart-line-item__quantity-dropdown');
      dropdown.querySelector('.cart-line-item--quantity-dropdown__options').classList.toggle('tw-hidden');
    }
    
    // Handle quantity option selection
    if (e.target.matches('[data-quantity-dropdown-option]')) {
      const selectedQuantity = parseInt(e.target.dataset.quantity, 10);
      const dropdown = e.target.closest('.cart-line-item__quantity-dropdown');
      const btn = dropdown.querySelector('.cart-line-item--quantity-dropdown__btn');
      const optionsContainer = dropdown.querySelector('.cart-line-item--quantity-dropdown__options');
      const counterWrapper = dropdown.closest('quantity-counter');
      
      if (!counterWrapper) return;
      
      const currentQuantityField = counterWrapper.querySelector('[data-quantity-field]');
      const minusButton = counterWrapper.querySelector('.js-counter-decrease');
      const plusButton = counterWrapper.querySelector('.js-counter-increase');
      
      if (!currentQuantityField || !minusButton || !plusButton) return;
      
      const currentQuantity = parseInt(currentQuantityField.value, 10);
      
      if (selectedQuantity !== currentQuantity) {
        const diff = Math.abs(selectedQuantity - currentQuantity);
        const buttonToClick = selectedQuantity > currentQuantity ? plusButton : minusButton;
        
        // Simulate multiple clicks if needed
        let clicksPerformed = 0;
        
        function performClick() {
          if (clicksPerformed < diff) {
            buttonToClick.click();
            clicksPerformed++;
            setTimeout(performClick, 50);
          }
        }
        
        performClick();
        
        // Update the dropdown button text
        setTimeout(() => {
          // Check if the button has an SVG child, if not, we need to add one
          const svgElement = btn.querySelector('svg') ? btn.querySelector('svg').outerHTML : '';
          btn.innerHTML = `${selectedQuantity} ${svgElement}`;
          optionsContainer.classList.add('tw-hidden');
        }, 50 * diff + 100); // Give enough time for all clicks to complete
      }
    }
    
    // Close dropdowns when clicking outside
    document.querySelectorAll('.cart-line-item__quantity-dropdown').forEach((dropdown) => {
      if (!dropdown.contains(e.target)) {
        dropdown.querySelector('.cart-line-item--quantity-dropdown__options').classList.add('tw-hidden');
      }
    });
    
    // Keep the dropdown button text in sync with the actual quantity
    document.querySelectorAll('quantity-counter').forEach(counter => {
      const quantityField = counter.querySelector('.js-counter-quantity');
      const dropdown = counter.querySelector('.cart-line-item__quantity-dropdown');
      
      if (quantityField && dropdown) {
        const btn = dropdown.querySelector('.cart-line-item--quantity-dropdown__btn');
        const svgElement = btn.querySelector('svg') ? btn.querySelector('svg').outerHTML : '';
        
        // Update on change
        quantityField.addEventListener('change', () => {
          btn.innerHTML = `${quantityField.value} ${svgElement}`;
        });
      }
    });
  });
  

// Transform footer links to be capitalized
document.addEventListener('DOMContentLoaded', function() {
  const elements = document.querySelectorAll('.wt-footer__list__item__text--underline');
  
  elements.forEach(element => {
    const text = element.textContent;
    const lowerCaseText = text.toLowerCase();
    
    // Special case for FAQS variations
    if (lowerCaseText === 'faqs' || lowerCaseText === 'faq' || lowerCaseText === "faq's") {
      element.textContent = 'FAQS';
    } else {
      const capitalizedText = lowerCaseText.replace(/(^|\s)\S/g, function(t) { 
        return t.toUpperCase(); 
      });
      element.textContent = capitalizedText;
    }
  });
});